import _defineProperty from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["clientId", "clientSecret", "clientType", "request"];
import _regeneratorRuntime from "/home/runner/work/help/help/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getUserAgent } from 'universal-user-agent';
import { request } from '@octokit/request';
import { createOAuthDeviceAuth } from '@octokit/auth-oauth-device';
import { exchangeWebFlowCode, refreshToken, checkToken, resetToken, deleteToken, deleteAuthorization } from '@octokit/oauth-methods';
import btoa from 'btoa-lite';
var VERSION = "1.3.0"; // @ts-nocheck there is only place for one of us in this file. And it's not you, TS

function getAuthentication(_x) {
  return _getAuthentication.apply(this, arguments);
}

function _getAuthentication() {
  _getAuthentication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state) {
    var _yield$exchangeWebFlo, authentication, deviceAuth, _authentication;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!("code" in state.strategyOptions)) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return exchangeWebFlowCode(_objectSpread(_objectSpread({
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              clientType: state.clientType
            }, state.strategyOptions), {}, {
              request: state.request
            }));

          case 3:
            _yield$exchangeWebFlo = _context.sent;
            authentication = _yield$exchangeWebFlo.authentication;
            return _context.abrupt("return", _objectSpread({
              type: "token",
              tokenType: "oauth"
            }, authentication));

          case 6:
            if (!("onVerification" in state.strategyOptions)) {
              _context.next = 12;
              break;
            }

            deviceAuth = createOAuthDeviceAuth(_objectSpread(_objectSpread({
              clientType: state.clientType,
              clientId: state.clientId
            }, state.strategyOptions), {}, {
              request: state.request
            }));
            _context.next = 10;
            return deviceAuth({
              type: "oauth"
            });

          case 10:
            _authentication = _context.sent;
            return _context.abrupt("return", _objectSpread({
              clientSecret: state.clientSecret
            }, _authentication));

          case 12:
            if (!("token" in state.strategyOptions)) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", _objectSpread({
              type: "token",
              tokenType: "oauth",
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              clientType: state.clientType
            }, state.strategyOptions));

          case 14:
            throw new Error("[@octokit/auth-oauth-user] Invalid strategy options");

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getAuthentication.apply(this, arguments);
}

function auth(_x2) {
  return _auth.apply(this, arguments);
}
/**
 * The following endpoints require an OAuth App to authenticate using its client_id and client_secret.
 *
 * - [`POST /applications/{client_id}/token`](https://docs.github.com/en/rest/reference/apps#check-a-token) - Check a token
 * - [`PATCH /applications/{client_id}/token`](https://docs.github.com/en/rest/reference/apps#reset-a-token) - Reset a token
 * - [`POST /applications/{client_id}/token/scoped`](https://docs.github.com/en/rest/reference/apps#create-a-scoped-access-token) - Create a scoped access token
 * - [`DELETE /applications/{client_id}/token`](https://docs.github.com/en/rest/reference/apps#delete-an-app-token) - Delete an app token
 * - [`DELETE /applications/{client_id}/grant`](https://docs.github.com/en/rest/reference/apps#delete-an-app-authorization) - Delete an app authorization
 *
 * deprecated:
 *
 * - [`GET /applications/{client_id}/tokens/{access_token}`](https://docs.github.com/en/rest/reference/apps#check-an-authorization) - Check an authorization
 * - [`POST /applications/{client_id}/tokens/{access_token}`](https://docs.github.com/en/rest/reference/apps#reset-an-authorization) - Reset an authorization
 * - [`DELETE /applications/{client_id}/tokens/{access_token}`](https://docs.github.com/en/rest/reference/apps#revoke-an-authorization-for-an-application) - Revoke an authorization for an application
 * - [`DELETE /applications/{client_id}/grants/{access_token}`](https://docs.github.com/en/rest/reference/apps#revoke-a-grant-for-an-application) - Revoke a grant for an application
 */


function _auth() {
  _auth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(state) {
    var options,
        currentAuthentication,
        _yield$refreshToken,
        authentication,
        method,
        _yield$method,
        _authentication2,
        _method,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};

            if (state.authentication) {
              _context2.next = 12;
              break;
            }

            if (!(state.clientType === "oauth-app")) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return getAuthentication(state);

          case 5:
            _context2.t0 = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.next = 10;
            return getAuthentication(state);

          case 10:
            _context2.t0 = _context2.sent;

          case 11:
            state.authentication = _context2.t0;

          case 12:
            if (!state.authentication.invalid) {
              _context2.next = 14;
              break;
            }

            throw new Error("[@octokit/auth-oauth-user] Token is invalid");

          case 14:
            currentAuthentication = state.authentication; // (auto) refresh for user-to-server tokens

            if (!("expiresAt" in currentAuthentication)) {
              _context2.next = 22;
              break;
            }

            if (!(options.type === "refresh" || new Date(currentAuthentication.expiresAt) < new Date())) {
              _context2.next = 22;
              break;
            }

            _context2.next = 19;
            return refreshToken({
              clientType: "github-app",
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              refreshToken: currentAuthentication.refreshToken,
              request: state.request
            });

          case 19:
            _yield$refreshToken = _context2.sent;
            authentication = _yield$refreshToken.authentication;
            state.authentication = _objectSpread({
              tokenType: "oauth",
              type: "token"
            }, authentication);

          case 22:
            if (!(options.type === "refresh")) {
              _context2.next = 27;
              break;
            }

            if (!(state.clientType === "oauth-app")) {
              _context2.next = 25;
              break;
            }

            throw new Error("[@octokit/auth-oauth-user] OAuth Apps do not support expiring tokens");

          case 25:
            if (currentAuthentication.hasOwnProperty("expiresAt")) {
              _context2.next = 27;
              break;
            }

            throw new Error("[@octokit/auth-oauth-user] Refresh token missing");

          case 27:
            if (!(options.type === "check" || options.type === "reset")) {
              _context2.next = 42;
              break;
            }

            method = options.type === "check" ? checkToken : resetToken;
            _context2.prev = 29;
            _context2.next = 32;
            return method({
              // @ts-expect-error making TS happy would require unnecessary code so no
              clientType: state.clientType,
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              token: state.authentication.token,
              request: state.request
            });

          case 32:
            _yield$method = _context2.sent;
            _authentication2 = _yield$method.authentication;
            state.authentication = _objectSpread({
              tokenType: "oauth",
              type: "token"
            }, _authentication2);
            return _context2.abrupt("return", state.authentication);

          case 38:
            _context2.prev = 38;
            _context2.t1 = _context2["catch"](29);

            // istanbul ignore else
            if (_context2.t1.status === 404) {
              _context2.t1.message = "[@octokit/auth-oauth-user] Token is invalid"; // @ts-expect-error TBD

              state.authentication.invalid = true;
            }

            throw _context2.t1;

          case 42:
            if (!(options.type === "delete" || options.type === "deleteAuthorization")) {
              _context2.next = 55;
              break;
            }

            _method = options.type === "delete" ? deleteToken : deleteAuthorization;
            _context2.prev = 44;
            _context2.next = 47;
            return _method({
              // @ts-expect-error making TS happy would require unnecessary code so no
              clientType: state.clientType,
              clientId: state.clientId,
              clientSecret: state.clientSecret,
              token: state.authentication.token,
              request: state.request
            });

          case 47:
            _context2.next = 53;
            break;

          case 49:
            _context2.prev = 49;
            _context2.t2 = _context2["catch"](44);

            if (!(_context2.t2.status !== 404)) {
              _context2.next = 53;
              break;
            }

            throw _context2.t2;

          case 53:
            state.authentication.invalid = true;
            return _context2.abrupt("return", state.authentication);

          case 55:
            return _context2.abrupt("return", state.authentication);

          case 56:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[29, 38], [44, 49]]);
  }));
  return _auth.apply(this, arguments);
}

var ROUTES_REQUIRING_BASIC_AUTH = /\/applications\/[^/]+\/(token|grant)s?/;

function requiresBasicAuth(url) {
  return url && ROUTES_REQUIRING_BASIC_AUTH.test(url);
}

function hook(_x3, _x4, _x5) {
  return _hook.apply(this, arguments);
}

function _hook() {
  _hook = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state, request, route) {
    var parameters,
        endpoint,
        credentials,
        _ref2,
        token,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            parameters = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
            endpoint = request.endpoint.merge(route, parameters); // Do not intercept OAuth Web/Device flow request

            if (!/\/login\/(oauth\/access_token|device\/code)$/.test(endpoint.url)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", request(endpoint));

          case 4:
            if (!requiresBasicAuth(endpoint.url)) {
              _context3.next = 8;
              break;
            }

            credentials = btoa("".concat(state.clientId, ":").concat(state.clientSecret));
            endpoint.headers.authorization = "basic ".concat(credentials);
            return _context3.abrupt("return", request(endpoint));

          case 8:
            if (!(state.clientType === "oauth-app")) {
              _context3.next = 14;
              break;
            }

            _context3.next = 11;
            return auth(_objectSpread(_objectSpread({}, state), {}, {
              request: request
            }));

          case 11:
            _context3.t0 = _context3.sent;
            _context3.next = 17;
            break;

          case 14:
            _context3.next = 16;
            return auth(_objectSpread(_objectSpread({}, state), {}, {
              request: request
            }));

          case 16:
            _context3.t0 = _context3.sent;

          case 17:
            _ref2 = _context3.t0;
            token = _ref2.token;
            endpoint.headers.authorization = "token " + token;
            return _context3.abrupt("return", request(endpoint));

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _hook.apply(this, arguments);
}

function createOAuthUserAuth(_ref) {
  var clientId = _ref.clientId,
      clientSecret = _ref.clientSecret,
      _ref$clientType = _ref.clientType,
      clientType = _ref$clientType === void 0 ? "oauth-app" : _ref$clientType,
      _ref$request = _ref.request,
      request$1 = _ref$request === void 0 ? request.defaults({
    headers: {
      "user-agent": "octokit-auth-oauth-app.js/".concat(VERSION, " ").concat(getUserAgent())
    }
  }) : _ref$request,
      strategyOptions = _objectWithoutProperties(_ref, _excluded);

  var state = Object.assign({
    clientType: clientType,
    clientId: clientId,
    clientSecret: clientSecret,
    strategyOptions: strategyOptions,
    request: request$1
  }); // @ts-expect-error not worth the extra code needed to appease TS

  return Object.assign(auth.bind(null, state), {
    // @ts-expect-error not worth the extra code needed to appease TS
    hook: hook.bind(null, state)
  });
}

createOAuthUserAuth.VERSION = VERSION;
export { createOAuthUserAuth, requiresBasicAuth };